/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminGetList } from '../fn/location-type-controller/admin-get-list';
import { AdminGetList$Params } from '../fn/location-type-controller/admin-get-list';
import { LocationTypeWithRelations } from '../models/location-type-with-relations';

@Injectable({ providedIn: 'root' })
export class LocationTypeControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `locationTypeControllerAdminGetList()` */
  static readonly LocationTypeControllerAdminGetListPath = '/admin/location-types';

  /**
   * Get all location types
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminGetList$Response(params?: AdminGetList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LocationTypeWithRelations>>> {
    return adminGetList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all location types
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminGetList(params?: AdminGetList$Params, context?: HttpContext): Observable<Array<LocationTypeWithRelations>> {
    return this.adminGetList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LocationTypeWithRelations>>): Array<LocationTypeWithRelations> => r.body)
    );
  }

}
